// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Options } from "./Options";
import {
  OptionsFromJSON,
  OptionsFromJSONTyped,
  OptionsToJSON,
  OptionsToJSONTyped,
} from "./Options";
import type { Filter } from "./Filter";
import { FilterFromJSON, FilterFromJSONTyped, FilterToJSON, FilterToJSONTyped } from "./Filter";
import type { Content } from "./Content";
import {
  ContentFromJSON,
  ContentFromJSONTyped,
  ContentToJSON,
  ContentToJSONTyped,
} from "./Content";
import type { SiteCreate } from "./SiteCreate";
import {
  SiteCreateFromJSON,
  SiteCreateFromJSONTyped,
  SiteCreateToJSON,
  SiteCreateToJSONTyped,
} from "./SiteCreate";

/**
 *
 * @export
 * @interface CatalogHarvesterCreate
 */
export interface CatalogHarvesterCreate {
  /**
   *
   */
  type: string;
  /**
   *
   */
  site: SiteCreate;
  /**
   *
   */
  options: Options;
  /**
   *
   */
  filters: Array<Filter>;
  /**
   *
   */
  content?: Content | null;
}

/**
 * Check if a given object implements the CatalogHarvesterCreate interface.
 */
export function instanceOfCatalogHarvesterCreate(value: object): value is CatalogHarvesterCreate {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("site" in value) || value["site"] === undefined) return false;
  if (!("options" in value) || value["options"] === undefined) return false;
  if (!("filters" in value) || value["filters"] === undefined) return false;
  return true;
}

export function CatalogHarvesterCreateFromJSON(json: any): CatalogHarvesterCreate {
  return CatalogHarvesterCreateFromJSONTyped(json, false);
}

export function CatalogHarvesterCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CatalogHarvesterCreate {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    site: SiteCreateFromJSON(json["site"]),
    options: OptionsFromJSON(json["options"]),
    filters: (json["filters"] as Array<any>).map(FilterFromJSON),
    content:
      json["content"] === undefined
        ? undefined
        : json["content"] === null
        ? null
        : ContentFromJSON(json["content"]),
  };
}

export function CatalogHarvesterCreateToJSON(json: any): CatalogHarvesterCreate {
  return CatalogHarvesterCreateToJSONTyped(json, false);
}

export function CatalogHarvesterCreateToJSONTyped(
  value?: CatalogHarvesterCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    site: SiteCreateToJSON(value["site"]),
    options: OptionsToJSON(value["options"]),
    filters: (value["filters"] as Array<any>).map(FilterToJSON),
    content: ContentToJSON(value["content"]),
  };
}
